module.exports = __webpack_public_path__ + "img/TestButtonExplainer.2d1f83b6.gif";